//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import BasePop from '../Pop/BasePop/BasePop.vue';
export default {
  components: {
    BasePop: BasePop
  },
  data: function data() {
    return {
      showIntro: false
    };
  }
};